export default "__VITE_ASSET__D611gFbl__"